import React from 'react';

import { useSearchState } from '../../context';

import Summary from './summary';
import Result from './result';
import Pagination from './pagination';

import { StyledSection, StyledSectionInner, StyledResultsList } from './styles';

const Results = () => {
  const { query, results, resultsTotal } = useSearchState();

  return (
    <StyledSection>
      <StyledSectionInner>
        <Summary query={query} total={resultsTotal} />

        <StyledResultsList>
          {results.map((item) => (
            <Result article={item} key={item.id} />
          ))}
        </StyledResultsList>

        <Pagination />
      </StyledSectionInner>
    </StyledSection>
  );
};

export default Results;
